import $ from 'jquery'

export function addressValidator(props){
    let errors = []
    //get all fields 
    const postalCodeElement = $("[data-postal-code]")
    const streetElement = $("[data-street]")
    const districtElement = $("[data-district]")
    const stateLocationElement = $("[data-state-location]")
    const cityLocationElement = $("[data-city-location]")

    const { cityLocation, district, postalCode, stateLocation, street } = props

    if( !postalCode ){//CEP
        const text = "Informe o CEP"
        postalCodeElement.addClass("has-error")
        $("[data-postal-code-info]").text( text ).addClass("text-danger")
    }
    if(!street){//RUA
        const text = "Informe a rua"
        streetElement.addClass("has-error")
        errors.push( text )
        $("[data-street-info]").text( text ).addClass("text-danger")
    }

    if(!district){//BAIRRo
        const text = "Informe seu Bairro"
        districtElement.addClass("has-error")
        errors.push(text)
        $("[data-district-info]").text( text ).addClass("text-danger")
    }

    if(!stateLocation){//Estado
        const text = "Selecione seu estado"
        stateLocationElement.addClass("has-error")
        errors.push(text)
        $("[data-state-info]").text( text ).addClass("text-danger")
    }

    if(!cityLocation){//Estado
        const text = "Informe sua cidade"
        cityLocationElement.addClass("has-error")
        errors.push(text)
        $("[data-city-info]").text( text ).addClass("text-danger")
    }


    

    return errors

}


// WEBPACK FOOTER //
// ./src/components/parts/utils/address-validators.js